import script from "./songScreen.vue?vue&type=script&lang=ts&setup=true"
export * from "./songScreen.vue?vue&type=script&lang=ts&setup=true"

import "./songScreen.vue?vue&type=style&index=0&id=421f2c7d&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-421f2c7d"]])

export default __exports__